/* DeerDoc Herd Supplement Calculator (asset version, pellets use deer-days coverage) */
(function(){
  // === CONFIG (includes your variant IDs) ===
  const PELLET_OPTIONS = [
    // Coverage: 50 lb = 25 deer × 30 days = 750 deer-days
    { name: "25 lb Bucket", deerDays: 375, url: "https://deerdoc.net/products/deerdoc-premium-flavonoid-supplemented-alfalfa-pellets", variantId: 50872076075239 },
    { name: "50 lb Bag",    deerDays: 750, url: "https://deerdoc.net/products/deerdoc-premium-flavonoid-supplemented-alfalfa-pellets", variantId: 50872076108007 },
    { name: "500 lb Bulk Bag", deerDays: 7500, url: "https://deerdoc.net/products/deerdoc-premium-flavonoid-supplemented-alfalfa-pellets", variantId: 51165116203239 }
  ];

  // Liquid mix rate: 250 mL per 50 lb feed (= 5 mL/lb)
  // UPDATED sizes: 1/2 Liter, 1 Liter, 1 Gallon, 55 Gallon Drum
  const LIQUID_OPTIONS = [
    { name: "½ Liter (500 mL)",    ml: 500,    url: "https://deerdoc.net/products/deerflavin", variantId: 51202288025831 },
    { name: "1 Liter (1,000 mL)",  ml: 1000,   url: "https://deerdoc.net/products/deerflavin", variantId: 51202288058599 },
    { name: "1 Gallon (3,785 mL)", ml: 3785,   url: "https://deerdoc.net/products/deerflavin", variantId: 51366560104679 },
    { name: "55 Gallon Drum",      ml: 208198, url: "https://deerdoc.net/products/deerflavin", variantId: 51366560137447 }
  ];

  function fmt(n){ return new Intl.NumberFormat(undefined,{maximumFractionDigits:2}).format(n); }

  // Prefer rounding up to larger sizes (fewer containers, better value)
  // Strategy:
  // - If the remainder fits in ANY single container, pick the smallest container that fully covers it (round up) and stop.
  // - Otherwise, take as many of the largest size as needed, then repeat.
  function pickCombo(requiredUnits, options, getUnits){
    const asc  = [...options].sort((a,b)=>getUnits(a)-getUnits(b)); // small -> big
    const desc = [...asc].reverse();                                // big  -> small

    let remaining = Math.ceil(requiredUnits);
    const picks = [];

    while (remaining > 0){
      // Can a single container cover what's left? (round up)
      const single = asc.find(opt => getUnits(opt) >= remaining);
      if (single){
        const existing = picks.find(p => p.name === single.name);
        if (existing) existing.qty += 1; else picks.push({...single, qty: 1});
        remaining = 0;
        break;
      }

      // Otherwise, use the largest size to knock the remainder down
      const largest = desc[0];
      const u = getUnits(largest);
      const q = Math.max(1, Math.floor(remaining / u)); // at least 1
      const existing = picks.find(p => p.name === largest.name);
      if (existing) existing.qty += q; else picks.push({...largest, qty: q});
      remaining -= q * u;
    }
    return picks;
  }

  // AJAX: add multiple line items
  async function addItemsToCart(items){
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if(!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function render(){
    const root = document.getElementById("deerdoc-calculator");
    if(!root) return; // container not present
    root.innerHTML = `
      <style>
        #deerdoc-calculator { font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji"; }
        #deerdoc-calculator .dd-card { border:1px solid #e5e7eb; border-radius:16px; padding:16px; box-shadow:0 1px 2px rgba(0,0,0,.04); background:#fff; }
        #deerdoc-calculator .dd-row { display:grid; gap:12px; grid-template-columns:1fr; }
        #deerdoc-calculator .dd-controls { display:flex; flex-wrap:wrap; gap:8px; align-items:center; }
        #deerdoc-calculator .dd-btn { border:1px solid #e5e7eb; border-radius:999px; padding:8px 14px; font-size:14px; background:#fff; cursor:pointer; }
        #deerdoc-calculator .dd-btn.active { background:#111827; color:#fff; }
        #deerdoc-calculator input[type="number"], #deerdoc-calculator select { width:100%; border:1px solid #e5e7eb; border-radius:12px; padding:8px 10px; }
        #deerdoc-calculator .dd-grid { display:grid; gap:12px; }
        @media (min-width:768px){ #deerdoc-calculator .dd-row{ grid-template-columns:repeat(3,1fr);} }
        #deerdoc-calculator .dd-note{ color:#6b7280; font-size:12px; }
        #deerdoc-calculator .dd-tag{ border:1px solid #e5e7eb; border-radius:999px; padding:8px 12px; font-size:13px; display:inline-flex; align-items:center; gap:8px; cursor:pointer; }
        #deerdoc-calculator .dd-footer{ font-size:12px; color:#6b7280; }
        #deerdoc-calculator .dd-linkbar a{ text-decoration:none; border:1px solid #e5e7eb; border-radius:999px; padding:8px 12px; font-size:13px; display:inline-block; }
        #deerdoc-calculator .dd-warn{ color:#b45309; background:#fffbeb; border:1px solid #f59e0b; padding:8px 10px; border-radius:10px; font-size:12px; }
        #deerdoc-calculator .dd-disabled{ opacity:.6; pointer-events:none; }
      </style>

      <div class="dd-wrap" aria-live="polite">
        <header style="margin-bottom:16px">
          <h2 style="font-size:24px; font-weight:600; margin:0">DeerDoc® Herd Supplement Calculator</h2>
          <p class="dd-note" style="margin-top:6px">Choose product type, herd size, and dosing plan. Pellets use coverage: <strong>50 lb = 25 deer × 30 days (750 deer-days)</strong>.</p>
        </header>

        <div class="dd-card dd-controls" style="margin-bottom:12px">
          <span style="font-size:14px; font-weight:600">Supplement type</span>
          <button class="dd-btn" data-type="pellets">Alfalfa Pellets</button>
          <button class="dd-btn" data-type="liquid">Liquid Concentrate</button>
        </div>

        <div class="dd-row" style="margin-bottom:16px">
          <div class="dd-card">
            <label style="font-size:14px; font-weight:600">Herd size (head)</label>
            <input type="number" min="1" value="25" id="dd-herd"/>
          </div>
          <div class="dd-card">
            <label style="font-size:14px; font-weight:600">Total days you’re planning for</label>
            <input type="number" min="1" value="30" id="dd-days"/>
            <p class="dd-note" style="margin-top:6px">We compute <em>active feeding days</em> from the dosing plan.</p>
          </div>
          <div class="dd-card">
            <label style="font-size:14px; font-weight:600">Dosing plan</label>
            <select id="dd-plan">
              <option value="maintenance">Maintenance (7 days on / 7 days off)</option>
              <option value="outbreak">Outbreak (minimum 30 active days)</option>
            </select>
          </div>
          <div class="dd-card" id="dd-feed-card" style="display:none">
            <label style="font-size:14px; font-weight:600">Avg. feed per deer per day (lb)</label>
            <input type="number" min="0.1" step="0.1" value="3" id="dd-feed"/>
            <p class="dd-note" style="margin-top:6px">Liquid only. Mix 250 mL per 50 lb (5 mL/lb).</p>
          </div>
        </div>

        <section id="dd-results"></section>

        <footer class="dd-footer" style="margin-top:16px">
          <strong>Dosing instructions</strong><br>
          <em>Maintenance:</em> 1 scoop per 2 heads per active day, using a <strong>7 days on / 7 days off</strong> schedule.<br>
          <em>Outbreak:</em> 1 scoop per head per active day for at least <strong>30 days</strong>, and continue until parasite egg counts are zero.<br>
          <span class="dd-note">Pellet recommendations use DeerDoc coverage (50 lb = 750 deer-days). Liquid uses 250 mL per 50 lb of feed (5 mL/lb).</span>
        </footer>
      </div>
    `;

    let type = "pellets";
    const herdEl = document.getElementById("dd-herd");
    const daysEl = document.getElementById("dd-days");
    const planEl = document.getElementById("dd-plan");
    const feedEl = document.getElementById("dd-feed");
    const feedCard = document.getElementById("dd-feed-card");
    const results = document.getElementById("dd-results");

    // Active feeding days from plan
    function getActiveDays(totalDays, plan){
      if (plan === 'maintenance') return Math.max(1, Math.ceil(totalDays * 0.5)); // 7-on/7-off
      return Math.max(30, totalDays); // outbreak min 30 active days
    }

    // Add-to-cart
    async function addItemsToCart(items){
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if(!res.ok) throw new Error('Add to cart failed');
      return res.json();
    }

    function hasMissingVariant(combo, catalog){
      return combo.some(p => !catalog.find(c => c.name === p.name)?.variantId);
    }

    function wireAddToCart(mode, combo){
      const btn = document.getElementById('dd-add-cart');
      const warn = document.getElementById('dd-add-warn');
      const catalog = (mode === 'pellets') ? PELLET_OPTIONS : LIQUID_OPTIONS;

      const disable = hasMissingVariant(combo, catalog);
      if (disable) {
        btn.classList.add('dd-disabled');
        if (warn) warn.style.display = 'block';
        return; // don’t bind click
      }
      if (warn) warn.style.display = 'none';
      btn.classList.remove('dd-disabled');

      btn.addEventListener('click', async () => {
        try {
          const items = combo.map(p => {
            const match = catalog.find(c => c.name === p.name);
            return { id: match.variantId, quantity: p.qty };
          });
          await addItemsToCart(items);
          window.location = '/cart';
        } catch (e) {
          alert('Sorry—couldn’t add items to cart. See console for details.');
          console.error(e);
        }
      });
    }

    function recalc(){
      const herd = Math.max(1, Number(herdEl.value || 1));
      const totalDays = Math.max(1, Number(daysEl.value || 1));
      const plan = planEl.value || 'maintenance';
      const activeDays = getActiveDays(totalDays, plan);

      const planMsg = (plan === 'maintenance')
        ? `Maintenance plan: ~50% of days active → ${fmt(activeDays)} active days of ${fmt(totalDays)}.`
        : `Outbreak plan: minimum 30 active days → using ${fmt(activeDays)} active days.`;

      if (type === "pellets"){
        feedCard.style.display = "none";

        // Deer-days needed = herd × activeDays
        const deerDaysNeeded = herd * activeDays;
        const combo = pickCombo(deerDaysNeeded, PELLET_OPTIONS, o=>o.deerDays);
        const totalCoverage = combo.reduce((s,o)=>s+o.deerDays*o.qty,0);

        results.innerHTML = `
          <div class="dd-card">
            <h3 style="font-size:18px; font-weight:600; margin:0 0 6px">Recommendation — Alfalfa Pellets</h3>
            <p class="dd-note">${planMsg}</p>
            <p class="dd-note">Coverage needed: <strong>${fmt(deerDaysNeeded)}</strong> deer-days. A 50 lb bag covers <strong>750</strong> deer-days.</p>

            <div class="dd-grid" style="grid-template-columns:repeat( auto-fit, minmax(220px,1fr) ); margin-top:12px">
              ${combo.map(p=>`
                <div class="dd-card" style="padding:12px">
                  <div style="font-size:14px; font-weight:600">${p.name}</div>
                  <div class="dd-note" style="margin-top:4px">Covers ${fmt(p.deerDays)} deer-days each</div>
                  <div style="font-size:22px; font-weight:700; margin-top:8px">× ${p.qty}</div>
                </div>
              `).join("")}
            </div>

            <div class="dd-card" style="margin-top:12px; display:flex; gap:12px; align-items:center; justify-content:space-between; flex-wrap:wrap">
              <div>
                <div style="font-size:14px">Total coverage: <strong>${fmt(totalCoverage)}</strong> deer-days</div>
                <div class="dd-note">Active feeding days used: ${fmt(activeDays)}.</div>
              </div>
              <div class="dd-linkbar" style="display:flex; gap:8px; flex-wrap:wrap">
                ${PELLET_OPTIONS.map(s=>`<a href="${s.url}" target="_blank" rel="noreferrer">${s.name}</a>`).join("")}
                <button id="dd-add-cart" class="dd-tag">Add recommended to cart</button>
              </div>
              <div id="dd-add-warn" class="dd-warn" style="display:none; margin-top:8px">One or more pellet variants are missing an ID.</div>
            </div>
          </div>
        `;
        wireAddToCart('pellets', combo);

      } else {
        // LIQUID
        feedCard.style.display = "block";

        const feedPerDeer = Math.max(0.1, Number(feedEl.value || 3));
        const totalFeedLbs = herd * activeDays * feedPerDeer;
        const mlNeeded = totalFeedLbs * 5; // 5 mL per lb
        const combo = pickCombo(mlNeeded, LIQUID_OPTIONS, o=>o.ml);
        const totalMl = combo.reduce((s,o)=>s+o.ml*o.qty,0);

        results.innerHTML = `
          <div class="dd-card">
            <h3 style="font-size:18px; font-weight:600; margin:0 0 6px">Recommendation — Liquid Concentrate</h3>
            <p class="dd-note">${planMsg}</p>
            <p class="dd-note">Total feed: <strong>${fmt(totalFeedLbs)}</strong> lb • Mix rate: <strong>250 mL / 50 lb</strong> (= 5 mL/lb)</p>
            <div style="font-size:14px; margin-top:6px">Concentrate needed: <strong>${fmt(mlNeeded)}</strong> mL</div>

            <div class="dd-grid" style="grid-template-columns:repeat( auto-fit, minmax(220px,1fr) ); margin-top:12px">
              ${combo.map(p=>`
                <div class="dd-card" style="padding:12px">
                  <div style="font-size:14px; font-weight:600">${p.name}</div>
                  <div class="dd-note" style="margin-top:4px">${fmt(p.ml)} mL each</div>
                  <div style="font-size:22px; font-weight:700; margin-top:8px">× ${p.qty}</div>
                </div>
              `).join("")}
            </div>

            <div class="dd-card" style="margin-top:12px; display:flex; gap:12px; align-items:center; justify-content:space-between; flex-wrap:wrap">
              <div>
                <div style="font-size:14px">Total volume: <strong>${fmt(totalMl)}</strong> mL</div>
                <div class="dd-note">Active feeding days used: ${fmt(activeDays)}.</div>
              </div>
              <div class="dd-linkbar" style="display:flex; gap:8px; flex-wrap:wrap">
                ${LIQUID_OPTIONS.map(s=>`<a href="${s.url}" target="_blank" rel="noreferrer">${s.name}</a>`).join("")}
                <button id="dd-add-cart" class="dd-tag">Add recommended to cart</button>
              </div>
              <div id="dd-add-warn" class="dd-warn" style="display:none; margin-top:8px">One or more liquid variants are missing an ID.</div>
            </div>
          </div>
        `;
        wireAddToCart('liquid', combo);
      }
    }

    // UI wiring
    const setActive = (t) => {
      type = t;
      document.querySelectorAll("#deerdoc-calculator .dd-btn").forEach(b=>b.classList.toggle("active", b.getAttribute("data-type")===t));
      recalc();
    };
    document.querySelectorAll("#deerdoc-calculator .dd-btn").forEach(btn=>{
      btn.addEventListener("click", () => setActive(btn.getAttribute("data-type")));
    });
    setActive("pellets");

    ["dd-herd","dd-days","dd-plan","dd-feed"].forEach(id=>{
      const el = document.getElementById(id);
      if(el) el.addEventListener("input", recalc);
    });
  }

  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", render); } else { render(); }
})();
